import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDoubleCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 13,
	viewBox: "0 0 18 13",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.62533 12.6388L0.666992 9.68048L1.6392 8.70827L3.61839 10.6736L7.28506 7.00688L8.25726 7.99994L3.62533 12.6388ZM3.62533 5.97215L0.666992 3.01381L1.6392 2.04161L3.61839 4.0069L7.28506 0.34021L8.25726 1.33327L3.62533 5.97215ZM9.83366 11.0277V9.63883H17.3337V11.0277H9.83366ZM9.83366 4.36104V2.97217H17.3337V4.36104H9.83366Z",
		fill: "currentColor"
	})
});
export default SvgDoubleCheck;
